import { useWeb3React } from '@web3-react/core';
import mcrtLogo from 'assets/icon-mcrt.png';
import axios from 'axios';
import { GEM_PACK_DATA } from 'config';
import { WEBSTORE_DATA } from 'config/index';
import { BigNumber, ethers } from 'ethers';
import { useMCRT } from 'hooks/useContract';
import GemsPack from 'pages/NFTInventory/GemsPack';
import { useEffect, useRef, useState } from 'react';
import './filter.css'
import {
  Badge,
  Button,
  Collapse,
  Dropdown,
  Spinner,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup
} from 'react-bootstrap';
import { FaAngleDown, FaAngleUp, FaFilter } from 'react-icons/fa6';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setData } from 'state/nftMarketplace';
import { toast } from 'react-toastify';
import InventoryItem from '../NFTInventory/NFTItem';
import MarketplaceCardSkeleton from './components/CardSkeleton';
import { useNFTData } from './GetNfts';
import './index.scss';
import MerchandiseItems from './MerchandiseItems';

const NFTMain = () => {

  const filterList = [
    'Latest',
    'Lowest',
    'Highest',
  ];

  const { account } = useWeb3React();

  const [limit, setLimit] = useState(21);

  useEffect(() => {
    const updateLimit = () => {
      if (window.innerWidth >= 1400) {
        setLimit(21);
      } else if (window.innerWidth >= 1200) {
        setLimit(18);
      } else if (window.innerWidth >= 992) {
        setLimit(20);
      } else {
        setLimit(16);
      }
    };
    window.addEventListener('resize', updateLimit);
    return () => window.removeEventListener('resize', updateLimit);
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [typeOpen, setTypeOpen] = useState(true);
  const [rarityOpen, setRarityOpen] = useState(true);
  const [priceOpen, setPriceOpen] = useState(true);
  const [nftType, setNFTType] = useState([]);
  const [bnbPrice, setBNBPrice] = useState(0);
  const [mcrtPrice, setMCRTPrice] = useState(0);
  const [nftRarity, setNFTRarity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [webstoreLoading, setWebstoreLoading] = useState(false);
  const [revelationItemsLoading, setRevelationItemsLoading] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(limit);
  const [webstoreItem, setWebstoreItem] = useState(limit);
  const [items, setItems] = useState(limit);
  const [revelationItems, setRevelationItems] = useState(limit);

  useEffect(() => {
    setItemsToShow(limit);
    setWebstoreItem(limit);
    setRevelationItems(limit);
    setItems(limit);
  }, [limit]);

  useEffect(() => {
    setIsLoading(false);
    setWebstoreLoading(false);
    setItemsLoading(false);
    setRevelationItemsLoading(false);
  }, [itemsToShow, webstoreItem, revelationItems, items]);

  const handleSeeMore = (value) => {
    if (value === 'webstore') setWebstoreLoading(true);
    if (value === 'items') setItemsLoading(true);
    if (value === 'genesis') setIsLoading(true);
    if (value === 'revelation') setRevelationItemsLoading(true);
    setTimeout(() => {
      value === 'revelation' && setRevelationItems(prev => prev + limit);
      value === 'genesis' && setItemsToShow(prev => prev + limit);
      value === 'webstore' && setWebstoreItem(prev => prev + limit);
      value === 'items' && setItems(prev => prev + limit);
    }, 1000);
  };

  const [nftListFilter, setNFTListFilter] = useState(
    filterList.includes(localStorage.getItem('filterlist'))
      ? localStorage.getItem('filterlist')
      : 'Latest',
  );

  const [pageNumber] = useState(0);
  const [purchasingItemId, setPurchasingItemId] = useState(null);
  const magicMCRT = useMCRT();
  const [isError, setIsError] = useState(false);

  const [expandedSection, setExpandedSection] = useState(null);

  useEffect(() => {
    if (mcrtPrice === 0) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [mcrtPrice]);

  const getPriceData = async () => {
    try {
      const priceData = await axios.get(
        `https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT`
      );
      if (priceData.data) {
        setBNBPrice(Number(priceData.data.price));
      }
      const lobbyBackURL = process.env.REACT_APP_LOBBY_BACK_URL;
      const response = await axios.get(`${lobbyBackURL}/mcrt-price`);
      const mcrtPrice = response?.data?.price;
      if (mcrtPrice) {
        setMCRTPrice(mcrtPrice);
      } else {
        setMCRTPrice(0);
      }
    } catch (error) {
      console.log('Error fetching price data:', error);
      setMCRTPrice(0);
    }
  };

  useEffect(() => {
    getPriceData();
  }, []);

  const getCurrentPrice = (inventoryData) => {
    const today = new Date();
    let data = { ...inventoryData };
    if (!data || !data.startingPrice || !data.endingPrice || !data.duration || !data.startAt)
      return 0;

    data.startingPrice = Number(data.startingPrice).toLocaleString('fullwide', { useGrouping: false });
    data.endingPrice = Number(data.endingPrice).toLocaleString('fullwide', { useGrouping: false });

    if (!data.isMCRT) {
      const bnbAmt = ethers.utils.formatEther(
        ethers.BigNumber.from(`${data.startingPrice}`).add(
          ethers.BigNumber.from(
            Math.min(data.duration, Math.ceil(today.getTime() / 1000.0 - data.startAt)),
          )
            .mul(ethers.BigNumber.from(`${data.endingPrice}`).sub(ethers.BigNumber.from(`${data.startingPrice}`)))
            .div(ethers.BigNumber.from(data.duration)),
        ),
      );
      return Number(bnbAmt);
    } else {
      const mcrtAmt = ethers.utils.formatUnits(
        ethers.BigNumber.from(`${data.startingPrice}`).add(
          ethers.BigNumber.from(
            Math.min(data.duration, Math.ceil(today.getTime() / 1000.0 - data.startAt)),
          )
            .mul(ethers.BigNumber.from(`${data.endingPrice}`).sub(ethers.BigNumber.from(`${data.startingPrice}`)))
            .div(ethers.BigNumber.from(data.duration)),
        ),
        9,
      );
      return Number(mcrtAmt);
    }
  };

  const handleChange = (val) => setNFTType(val);

  const handleRarity = (val) => {
    if (val) {
      setNFTRarity(val);
    } else {
      setNFTRarity([]);
    }
  };

  const resetFilter = () => {
    setNFTRarity([]);
    setNFTType([]);
    setNFTListFilter('Latest');
  };

  const convertToBigNumber = (amount) => {
    return ethers.utils.parseUnits(amount.toString(), 9).toString();
  };

  const handlePurchase = async (pack) => {
    if (!account) {
      toast.warning('Please connect your wallet to make a purchase', {
        position: 'top-center',
        autoClose: 5000,
      });
      return;
    }
    if (mcrtPrice <= 0) {
      toast.error('Unable to fetch MCRT price. Please try again later.');
      return;
    }
    try {
      if (isError) throw new Error('Error while processing transaction');
      setPurchasingItemId(pack.id);
      const packPriceInMCRT = pack.mcrtPrice;
      const mcrtAmt = convertToBigNumber(packPriceInMCRT);
      const treasury_wallet_address = process.env.REACT_APP_TREASURY_WALLET_ADDRESS;
      const allowance = await magicMCRT.methods.allowance(account, treasury_wallet_address).call();
      if (BigNumber.from(String(allowance)).lt(BigNumber.from(String(mcrtAmt)))) {
        await magicMCRT.methods.approve(account, mcrtAmt).send({
          from: account,
          gasPrice: ethers.utils.parseUnits('10', 'gwei'),
          gas: 100000,
        });
      }
      const contract = await magicMCRT.methods
        .transferFrom(account, treasury_wallet_address, mcrtAmt)
        .send({ from: account, gasPrice: ethers.utils.parseUnits('10', 'gwei'), gas: 100000 });
      if (!contract.transactionHash) throw new Error('There was an error in completing the transaction.');
    } catch (error) {
      console.error('Purchase error:', error);
      toast.error(`There was an error while processing your transaction.`);
    } finally {
      setPurchasingItemId(null);
    }
  };

  const [activeTab, setActiveTab] = useState('NFTs');
  const activeFiltersCount = nftType.length + (nftRarity?.length || 0) + (nftListFilter ? 1 : 0);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const genesiscontractAddress = process.env.REACT_APP_GENESIS_CONTRACT_ADDRESS;
  const revelationcontractAddress = process.env.REACT_APP_REVELATION_CONTRACT_ADDRESS;

  const { data: genesisData, isLoading: genesisLoading, error: genesisError } = useNFTData(genesiscontractAddress, pageNumber, nftListFilter, nftRarity, nftType);
  const { data: revelationData, isLoading: revelationLoading, error: revelationError } = useNFTData(revelationcontractAddress, pageNumber, nftListFilter, nftRarity);

  const [filterSectionVisible, setFilterSectionVisible] = useState(false);
  const toggleFilterSection = () => setFilterSectionVisible(v => !v);

  /* ── Webstore card: renders a single card (used in both row and expanded views) ── */
  const WebstoreCard = ({ pack }) => (
    <div className="webstore-card">
      <div className="webstore-image-container imgRes">
        <img
          className="object-fit-cover"
          src={pack.image || 'https://via.placeholder.com/300x300.png?text=No+Image'}
          alt={pack.name}
        />
      </div>
      <div className="webstore-card-content">
        <h3 className="webstore-card-title">{pack.name}</h3>
        <p className="webstore-price">{pack?.mcrtPrice?.toLocaleString()} MCRT</p>
        <Button
          className="webstore-purchase-button"
          onClick={(e) => { e.stopPropagation(); handlePurchase(pack); }}
          disabled={purchasingItemId === pack.id}
        >
          {purchasingItemId === pack.id ? (
            <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
          ) : (
            <><img src={mcrtLogo} width={18} height={18} alt="MCRT" /><span className="payButton">Pay with MCRT</span></>
          )}
        </Button>
      </div>
    </div>
  );

  /* ── Genesis filter bar (shared between expanded view) ── */
  const GenesisFilterBar = () => (
    <div className="horizontal-filter w-100 mb-4">
      <div className="horizontal-filter__container">
        <div className="horizontal-filter__header" onClick={toggleFilterSection} style={{ cursor: 'pointer' }}>
          <div className="horizontal-filter__title">
            <FaFilter className="horizontal-filter__title-icon" />
            <span>Filter Items</span>
            {activeFiltersCount > 0 && (
              <Badge className="horizontal-filter__active-count">{activeFiltersCount}</Badge>
            )}
            <span className="ms-2">{filterSectionVisible ? <FaAngleUp /> : <FaAngleDown />}</span>
          </div>
          <div className="horizontal-filter__actions">
            <button
              className="horizontal-filter__reset-btn"
              onClick={(e) => { e.stopPropagation(); resetFilter(); }}
            >
              Reset All
            </button>
          </div>
        </div>

        <Collapse in={filterSectionVisible}>
          <div className="horizontal-filter__controls">
            {/* Character Type */}
            <div className="horizontal-filter__group">
              <div className="horizontal-filter__group-header" onClick={() => setTypeOpen(!typeOpen)}>
                <span className="horizontal-filter__group-title">Character Type</span>
                <div className="horizontal-filter__group-indicators">
                  {nftType.length > 0 && <Badge className="horizontal-filter__group-badge">{nftType.length}</Badge>}
                  {typeOpen ? <FaAngleUp /> : <FaAngleDown />}
                </div>
              </div>
              <Collapse in={typeOpen}>
                <div className="horizontal-filter__group-content">
                  <ToggleButtonGroup type="checkbox" value={nftType} onChange={handleChange} className="horizontal-filter__toggle-group">
                    <ToggleButton id="type-knight" value="Knight" className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--knight ${nftType.includes('Knight') ? 'active' : ''}`}>
                      <span className="horizontal-filter__toggle-icon">⚔️</span> Knight
                    </ToggleButton>
                    <ToggleButton id="type-hunter" value="Hunter" className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--hunter ${nftType.includes('Hunter') ? 'active' : ''}`}>
                      <span className="horizontal-filter__toggle-icon">🏹</span> Hunter
                    </ToggleButton>
                    <ToggleButton id="type-arcana" value="Keeper" className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--arcana ${nftType.includes('Keeper') ? 'active' : ''}`}>
                      <span className="horizontal-filter__toggle-icon">🔮</span> Arcana
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </Collapse>
            </div>

            {/* Rarity */}
            <div className="horizontal-filter__group">
              <div className="horizontal-filter__group-header" onClick={() => setRarityOpen(!rarityOpen)}>
                <span className="horizontal-filter__group-title">Rarity</span>
                <div className="horizontal-filter__group-indicators">
                  {(nftRarity?.length || 0) > 0 && <Badge className="horizontal-filter__group-badge">{nftRarity.length}</Badge>}
                  {rarityOpen ? <FaAngleUp /> : <FaAngleDown />}
                </div>
              </div>
              <Collapse in={rarityOpen}>
                <div className="horizontal-filter__group-content">
                  <ToggleButtonGroup type="checkbox" value={nftRarity} onChange={handleRarity} className="horizontal-filter__toggle-group">
                    <ToggleButton id="rarity-rare" value="rare" className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--rare ${nftRarity.includes('rare') ? 'active' : ''}`}>
                      <span className="horizontal-filter__rarity-gem horizontal-filter__rarity-gem--rare"></span> Rare
                    </ToggleButton>
                    <ToggleButton id="rarity-epic" value="epic" className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--epic ${nftRarity.includes('epic') ? 'active' : ''}`}>
                      <span className="horizontal-filter__rarity-gem horizontal-filter__rarity-gem--epic"></span> Epic
                    </ToggleButton>
                    <ToggleButton id="rarity-legendary" value="legendary" className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--legendary ${nftRarity.includes('legendary') ? 'active' : ''}`}>
                      <span className="horizontal-filter__rarity-gem horizontal-filter__rarity-gem--legendary"></span> Legendary
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </Collapse>
            </div>

            {/* Price */}
            <div className="horizontal-filter__group">
              <div className="horizontal-filter__group-header" onClick={() => setPriceOpen(!priceOpen)}>
                <span className="horizontal-filter__group-title">Price</span>
                <div className="horizontal-filter__group-indicators">
                  {nftListFilter && <Badge className="horizontal-filter__group-badge">1</Badge>}
                  {priceOpen ? <FaAngleUp /> : <FaAngleDown />}
                </div>
              </div>
              <Collapse in={priceOpen}>
                <div className="horizontal-filter__group-content">
                  <ToggleButtonGroup type="radio" name="price" value={nftListFilter} onChange={(v) => setNFTListFilter(v)} className="horizontal-filter__toggle-group">
                    {filterList?.map((filter, i) => (
                      <ToggleButton key={i} id={`price-${i}`} value={filter} className={`horizontal-filter__toggle-btn horizontal-filter__toggle-btn--price ${nftListFilter === filter ? 'active' : ''}`}>
                        {filter}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </div>
              </Collapse>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );

  return (
    <div className="main">
      {/* ── Mobile tab bar ─────────────────────────────────────── */}
      <div className="main__mobile--header sticky-tabs d-lg-none d-flex">
        <Dropdown
          onSelect={(val) => {
            setActiveTab(val);
            if (val === 'NFTs') setExpandedSection('genesis');
            else if (val === 'Revelation') setExpandedSection('revelation');
            else if (val === 'Items') setExpandedSection('items');
            else if (val === 'Merchandise') setExpandedSection('merchandise');
            else if (val === 'Webstore') setExpandedSection('webstore');
            else setExpandedSection(null);
          }}
        >
          <Dropdown.Toggle id="dropdown-basic">
            {activeTab === 'NFTs' ? 'Genesis' : activeTab === 'Webstore' ? 'In-Game Assets' : activeTab}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item href="#" eventKey="NFTs">Genesis</Dropdown.Item>
            <Dropdown.Item href="#" eventKey="Revelation">Revelation</Dropdown.Item>
            <Dropdown.Item href="#" eventKey="Items">Items</Dropdown.Item>
            <Dropdown.Item href="#" eventKey="Merchandise">Merchandise</Dropdown.Item>
            <Dropdown.Item href="#" eventKey="Webstore">In-Game Assets</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* ── Desktop tab bar ──────────────────────────────────── */}
      <div className="sticky-tabs d-none d-lg-block">
        <Tabs
          activeKey={activeTab}
          onSelect={(key) => {
            if (dropdownVisible) return;
            setActiveTab(key);
            if (key === 'NFTs') setExpandedSection('genesis');
            else if (key === 'Items') setExpandedSection('items');
            else if (key === 'Merchandise') setExpandedSection('merchandise');
            else if (key === 'Webstore') setExpandedSection('webstore');
            else setExpandedSection(null);
          }}
        >
          <Tab
            eventKey="NFTs"
            className="position-relative"
            title={
              <div
                onMouseEnter={() => setDropdownVisible(true)}
                onMouseLeave={() => setDropdownVisible(false)}
              >
                NFTs
                {dropdownVisible && (
                  <div className="nft-dropdown">
                    <Button
                      onClick={() => {
                        setActiveTab('NFTs');
                        setExpandedSection('genesis');
                        setDropdownVisible(false);
                      }}
                    >
                      Genesis
                    </Button>
                    <Button
                      onClick={() => {
                        setActiveTab('Revelation');
                        setExpandedSection('revelation');
                        setDropdownVisible(false);
                      }}
                    >
                      Revelation
                    </Button>
                  </div>
                )}
              </div>
            }
          />
          <Tab eventKey="Items" title="Items" />
          <Tab eventKey="Merchandise" title="Merchandise" />
          <Tab eventKey="Webstore" title="In-Game Assets" />
        </Tabs>
      </div>

      {/* ── Main content ─────────────────────────────────────── */}
      <div className="category-page">
        {expandedSection ? (
          /* ══════════════ EXPANDED VIEW ══════════════ */
          <div className="category-expanded">
            <button className="expanded-back-btn" onClick={() => setExpandedSection(null)}>
              <span className="expanded-back-btn__arrow">←</span>
              <span>All Categories</span>
            </button>

            {/* Genesis expanded */}
            {expandedSection === 'genesis' && (
              <div>
                <div className="category-expanded__header">
                  <h2>Genesis</h2>
                </div>
                <GenesisFilterBar />
                {genesisLoading ? (
                  <div className="cards-grid gap-2">
                    {Array.from({ length: 20 }).map((_, i) => <MarketplaceCardSkeleton key={i} />)}
                  </div>
                ) : genesisError ? (
                  <div className="empty-state">Error fetching Genesis Data</div>
                ) : genesisData?.length === 0 ? (
                  <div className="empty-state">No Genesis items available</div>
                ) : (
                  <>
                    <div className="cards-grid gap-2">
                      {genesisData?.slice(0, itemsToShow)?.map((inventoryNft, index) => (
                        <div key={index}>
                          {!inventoryNft.isMCRT ? (
                            <InventoryItem
                              data={inventoryNft}
                              onClick={() => {
                                const nft = { ...inventoryNft, contractAddress: genesiscontractAddress };
                                dispatch(setData({ selectedNft: nft }));
                                navigate(`/marketplace/${genesiscontractAddress}/${inventoryNft.tokenID}`);
                              }}
                              price={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft)}
                              priceDollar={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * bnbPrice}
                            />
                          ) : (
                            <InventoryItem
                              data={inventoryNft}
                              onClick={() => navigate(`/marketplace/${genesiscontractAddress}/${inventoryNft.tokenID}`)}
                              mcrtPrice={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft)}
                              mcrtPriceDollar={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * mcrtPrice}
                            />
                          )}
                        </div>
                      ))}
                      {isLoading && Array.from({ length: 20 }).map((_, i) => <MarketplaceCardSkeleton key={i} />)}
                    </div>
                    {genesisData?.length > itemsToShow && (
                      <div className="text-center d-flex justify-content-center pt-5">
                        <Button className="see-more-btn px-4 py-2" onClick={() => handleSeeMore('genesis')}>See More</Button>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Revelation expanded */}
            {expandedSection === 'revelation' && (
              <div>
                <div className="category-expanded__header">
                  <h2>Revelation</h2>
                </div>
                {revelationLoading ? (
                  <div className="cards-grid gap-2">
                    {Array.from({ length: 20 }).map((_, i) => <MarketplaceCardSkeleton key={i} />)}
                  </div>
                ) : revelationError ? (
                  <div className="empty-state">Error fetching Revelation Data</div>
                ) : revelationData?.length === 0 ? (
                  <div className="empty-state">No Revelation items available</div>
                ) : (
                  <>
                    <div className="cards-grid gap-2">
                      {revelationData?.slice(0, revelationItems)?.map((inventoryNft, index) => (
                        <div className="revelation-card-wrap" key={index}>
                          <InventoryItem
                            data={inventoryNft}
                            onClick={() => {
                              const nft = { ...inventoryNft, contractAddress: revelationcontractAddress };
                              dispatch(setData({ selectedNft: nft }));
                              navigate(`/marketplace/${revelationcontractAddress}/${inventoryNft.tokenID}`);
                            }}
                            mcrtPrice={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft)}
                            mcrtPriceDollar={
                              inventoryNft.isMCRT
                                ? (getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * mcrtPrice)
                                : (getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * bnbPrice)
                            }
                          />
                        </div>
                      ))}
                      {revelationItemsLoading && Array.from({ length: 20 }).map((_, i) => <MarketplaceCardSkeleton key={i} />)}
                    </div>
                    {revelationData?.length > revelationItems && (
                      <div className="text-center d-flex justify-content-center pt-5">
                        <Button className="see-more-btn px-4 py-2" onClick={() => handleSeeMore('revelation')}>See More</Button>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Items expanded */}
            {expandedSection === 'items' && (
              <div>
                <div className="category-expanded__header">
                  <h2>Items</h2>
                </div>
                <div className="cards-grid gap-2">
                  {GEM_PACK_DATA?.slice(0, items)?.map((pack, i) => (
                    <GemsPack key={i} mcrtPrice={mcrtPrice} packData={pack} />
                  ))}
                  {itemsLoading && Array.from({ length: 20 }).map((_, i) => <MarketplaceCardSkeleton key={i} />)}
                </div>
                {GEM_PACK_DATA?.length > items && (
                  <div className="text-center d-flex justify-content-center pt-5">
                    <Button className="see-more-btn px-4 py-2" onClick={() => handleSeeMore('items')}>See More</Button>
                  </div>
                )}
              </div>
            )}

            {/* Merchandise expanded */}
            {expandedSection === 'merchandise' && (
              <div>
                <div className="category-expanded__header">
                  <h2>Official Merchandise</h2>
                </div>
                <MerchandiseItems
                  account={account}
                  magicMCRT={magicMCRT}
                  isError={isError}
                  limit={limit}
                  mcrtPrice={mcrtPrice}
                />
              </div>
            )}

            {/* Webstore expanded */}
            {expandedSection === 'webstore' && (
              <div>
                <div className="category-expanded__header">
                  <h2>In-Game Assets</h2>
                </div>
                <div className="cards-grid gap-2">
                  {WEBSTORE_DATA?.slice(0, webstoreItem)?.map((pack, i) => (
                    <WebstoreCard key={i} pack={pack} />
                  ))}
                  {webstoreLoading && Array.from({ length: 20 }).map((_, i) => <MarketplaceCardSkeleton key={i} />)}
                </div>
                {WEBSTORE_DATA?.length > webstoreItem && (
                  <div className="text-center d-flex justify-content-center pt-5">
                    <Button className="see-more-btn px-4 py-2" onClick={() => handleSeeMore('webstore')}>See More</Button>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          /* ══════════════ NETFLIX ROWS ══════════════ */
          <div className="category-rows">

            {/* Genesis Row */}
            <div className="category-row">
              <div className="category-row__header">
                <h2 className="category-row__title">Genesis</h2>
                <button
                  className="category-row__see-all"
                  onClick={() => { setActiveTab('NFTs'); setExpandedSection('genesis'); }}
                >
                  See All →
                </button>
              </div>
              <div className="category-row__scroll">
                <div className="category-row__track">
                  {genesisLoading
                    ? Array.from({ length: 8 }).map((_, i) => (
                        <div className="category-row__card" key={i}><MarketplaceCardSkeleton /></div>
                      ))
                    : genesisData?.slice(0, 12)?.map((inventoryNft, i) => (
                        <div className="category-row__card" key={i}>
                          {!inventoryNft.isMCRT ? (
                            <InventoryItem
                              data={inventoryNft}
                              onClick={() => {
                                const nft = { ...inventoryNft, contractAddress: genesiscontractAddress };
                                dispatch(setData({ selectedNft: nft }));
                                navigate(`/marketplace/${genesiscontractAddress}/${inventoryNft.tokenID}`);
                              }}
                              price={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft)}
                              priceDollar={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * bnbPrice}
                            />
                          ) : (
                            <InventoryItem
                              data={inventoryNft}
                              onClick={() => navigate(`/marketplace/${genesiscontractAddress}/${inventoryNft.tokenID}`)}
                              mcrtPrice={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft)}
                              mcrtPriceDollar={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * mcrtPrice}
                            />
                          )}
                        </div>
                      ))
                  }
                </div>
              </div>
            </div>

            {/* Revelation Row */}
            <div className="category-row">
              <div className="category-row__header">
                <h2 className="category-row__title">Revelation</h2>
                <button
                  className="category-row__see-all"
                  onClick={() => { setActiveTab('Revelation'); setExpandedSection('revelation'); }}
                >
                  See All →
                </button>
              </div>
              <div className="category-row__scroll">
                <div className="category-row__track">
                  {revelationLoading
                    ? Array.from({ length: 8 }).map((_, i) => (
                        <div className="category-row__card" key={i}><MarketplaceCardSkeleton /></div>
                      ))
                    : revelationData?.slice(0, 12)?.map((inventoryNft, i) => (
                        <div className="category-row__card revelation-card-wrap" key={i}>
                          <InventoryItem
                            data={inventoryNft}
                            onClick={() => {
                              const nft = { ...inventoryNft, contractAddress: revelationcontractAddress };
                              dispatch(setData({ selectedNft: nft }));
                              navigate(`/marketplace/${revelationcontractAddress}/${inventoryNft.tokenID}`);
                            }}
                            mcrtPrice={getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft)}
                            mcrtPriceDollar={
                              inventoryNft.isMCRT
                                ? (getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * mcrtPrice)
                                : (getCurrentPrice(inventoryNft) === 0 ? null : getCurrentPrice(inventoryNft) * bnbPrice)
                            }
                          />
                        </div>
                      ))
                  }
                </div>
              </div>
            </div>

            {/* Items Row */}
            <div className="category-row">
              <div className="category-row__header">
                <h2 className="category-row__title">Items</h2>
                <button
                  className="category-row__see-all"
                  onClick={() => { setActiveTab('Items'); setExpandedSection('items'); }}
                >
                  See All →
                </button>
              </div>
              <div className="category-row__scroll">
                <div className="category-row__track">
                  {GEM_PACK_DATA?.slice(0, 8)?.map((pack, i) => (
                    <div className="category-row__card" key={i}>
                      <GemsPack mcrtPrice={mcrtPrice} packData={pack} />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Merchandise Row — teaser banner */}
            <div className="category-row">
              <div className="category-row__header">
                <h2 className="category-row__title">Official Merchandise</h2>
                <button
                  className="category-row__see-all"
                  onClick={() => { setActiveTab('Merchandise'); setExpandedSection('merchandise'); }}
                >
                  See All →
                </button>
              </div>
              <button
                className="category-row__merch-banner"
                onClick={() => { setActiveTab('Merchandise'); setExpandedSection('merchandise'); }}
              >
                <div className="category-row__merch-banner-orbs" aria-hidden="true">
                  <span className="orb orb--1" />
                  <span className="orb orb--2" />
                  <span className="orb orb--3" />
                </div>
                <div className="category-row__merch-banner-body">
                  <span className="category-row__merch-banner-eyebrow">New Collection</span>
                  <h3 className="category-row__merch-banner-title">Official Merchandise</h3>
                  <p className="category-row__merch-banner-desc">Exclusive MagicCraft collectibles and apparel</p>
                </div>
                <span className="category-row__merch-banner-cta">Browse Collection →</span>
              </button>
            </div>

            {/* Webstore Row */}
            <div className="category-row">
              <div className="category-row__header">
                <h2 className="category-row__title">In-Game Assets</h2>
                <button
                  className="category-row__see-all"
                  onClick={() => { setActiveTab('Webstore'); setExpandedSection('webstore'); }}
                >
                  See All →
                </button>
              </div>
              <div className="category-row__scroll">
                <div className="category-row__track">
                  {WEBSTORE_DATA?.slice(0, 8)?.map((pack, i) => (
                    <div className="category-row__card" key={i}>
                      <WebstoreCard pack={pack} />
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        )}
      </div>

      {/* ── Webstore inline styles (global, applied in both views) ── */}
      <style jsx global>{`
        .webstore-card {
          background: #13142b;
          border: 1px solid rgba(255, 255, 255, 0.07);
          border-radius: 12px;
          overflow: hidden;
          transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
        }
        .webstore-card:hover {
          border-color: #83fff8;
          transform: translateY(-6px);
          box-shadow: 0 0 0 1px rgba(131, 255, 248, 0.15), 0 8px 32px rgba(110, 234, 212, 0.2);
        }
        .webstore-image-container {
          position: relative;
          width: 100%;
          padding-top: 100%;
          overflow: hidden;
          background: #0d0e1f;
        }
        .webstore-image-container::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 50%;
          background: linear-gradient(to top, #13142b 0%, transparent 100%);
          z-index: 2;
          pointer-events: none;
        }
        .webstore-image-container img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.35s ease;
        }
        .webstore-card:hover .webstore-image-container img {
          transform: scale(1.04);
        }
        .webstore-card-content {
          padding: 10px 12px 12px;
          display: flex;
          flex-direction: column;
          gap: 6px;
          flex-grow: 1;
        }
        .webstore-card-title {
          color: white;
          font-size: 14px;
          font-weight: 700;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          letter-spacing: 0.01em;
        }
        .webstore-price {
          color: #83fff8;
          font-weight: 700;
          font-size: 14px;
          margin: 0;
          line-height: 1.4;
        }
        .webstore-purchase-button {
          position: relative;
          overflow: hidden;
          background: rgba(131, 255, 248, 0.08);
          border: 1px solid rgba(131, 255, 248, 0.3);
          color: #83fff8;
          border-radius: 8px;
          padding: 8px 12px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-top: auto;
        }
        .webstore-purchase-button:hover:not(:disabled) {
          background: rgba(131, 255, 248, 0.15);
          border-color: #83fff8;
          box-shadow: 0 0 16px rgba(131, 255, 248, 0.2);
          transform: translateY(-1px);
          color: #83fff8;
        }
        .webstore-purchase-button:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default NFTMain;
